// extracted by mini-css-extract-plugin
module.exports = {"main":"PaymentSystems_main__2q-Tq","item":"PaymentSystems_item__QoI-Z"};